<template>
    <div v-if="lenderList.length > 0" class="container content-space-1">
        <div class="col-12 col-lg-9 mx-lg-auto">
            <div v-if="$validateText(text)" class="rich-text mb-4" v-html="$prismic.asHtml(text)" />
            <ul class="list-unstyled d-flex flex-column gap-3 mb-0">
                <li v-for="lender in lenderList" :key="lender.id">
                    <nuxt-link 
                        :to="$prismic.linkResolver(lender)" 
                        class="card border py-2 px-3 d-flex flex-row justify-content-between align-items-center gap-2 card-transition"
                    >
                        <div class="d-flex align-items-center hpx-60">
                            <prismic-image :img="lender.data.logo" w="120" class="max-wpx-80 max-wpx-md-120 max-height-100 object-fit-contain" />
                        </div>
                        <lender-review-rating :rating="lender.data.core_api.ratings" />
                    </nuxt-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import LenderReviewRating from '@/components/LenderReviewRating.vue';

export default {
    components: { LenderReviewRating },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            hasList: this.$validateContentRelationship(this.slice.primary.list),
            hasItems: this.slice.items.length > 0 && this.slice.items.some(item => this.$validateContentRelationship(item.lender)),
        };
    },
    computed: {
        text() {
            return this.slice.primary.text;
        },
        allLenders() {
            return this.$store.state.lenders;
        },
        showAll() {
            return !(this.hasList || this.hasItems);
        },
        lenders() {
            let lendersToDisplay;
            if (this.hasList) {
                lendersToDisplay = this.$store.state.lists[this.slice.primary.list.id].data.items
                    .filter(iterator => this.$validateContentRelationship(iterator.item))
                    .map(iterator => this.allLenders[iterator.item.id]);
            }
            else if (this.hasItems) {
                lendersToDisplay = this.slice.items
                    .filter(iterator => this.$validateContentRelationship(iterator.lender))
                    .map(iterator => this.allLenders[iterator.lender.id]);
            }
            else {
                lendersToDisplay = Object.values(this.allLenders);
            }

            if (lendersToDisplay.length > 0 && this.slice.primary.show_only_list_enabled) {
                return lendersToDisplay.filter(lender => lender.data.lists_enabled);
            }
            return lendersToDisplay;
        },
        sortBy() {
            const fallbackSort = this.showAll ? 'rating' : 'default';
            return this.slice.primary.sort_by || fallbackSort;
        },
        limit() {
            return this.slice.primary.limit || this.lenders.length;
        },
        orderedLenders() {
            if (this.sortBy === 'default') {
                return this.lenders;
            }
            const epcOrderedLenders = this.$getOrderedList(this.lenders, this.allLenders, this.$models.Loan);
            const sortConfig = {
                rating: (a, b) => (b.data.core_api.ratings.average_score || 0) - (a.data.core_api.ratings.average_score || 0),
                alphabetical: (a, b) => a.data.title.localeCompare(b.data.title),
            };

            const sortedLenders = epcOrderedLenders.slice().sort(sortConfig[this.sortBy]);
            return sortedLenders;
        },
        lenderList() {
            return this.orderedLenders.slice(0, this.limit);
        }
    }
};
</script>